<app-header [title]="title" (menuToggle)="toggleMenu()"></app-header>

<app-side-navigation-menu #menuLateral>
    <ng-content></ng-content>
</app-side-navigation-menu>
